import styled from "@emotion/styled";

export const PromotionalBlockWrapper = styled.button<{
  backgroundColor?: string;
  textColor?: string;
  highlightColor?: string;
}>`
  position: relative;
  display: flex;
  flex-direction: row;
  place-items: center;
  gap: ${({ theme }) => theme.space.space8};
  width: 100%;
  height: ${({ theme }) => theme.space.space64};
  background-color: ${({ theme, backgroundColor }) =>
    `${backgroundColor || theme.colors.semantic.blue + "10"}`};
  padding: ${({ theme }) => theme.space._12};
  border: none;
  border-radius: ${({ theme }) => theme.space.space8};
  cursor: pointer;
  overflow: hidden;
  transition: background-color 350ms ease-in-out;

  &.no-click {
    cursor: initial;
  }

  .icon {
    flex-shrink: 0;

    path {
      fill: ${({ theme, highlightColor }) =>
        highlightColor || theme.colors.semantic.blue};
    }
  }

  .message {
    transform: translateY(0);
  }

  .promo-message {
    text-align: left;
  }

  .promo-code {
    color: ${({ theme, highlightColor }) =>
      highlightColor || theme.colors.semantic.blue};
    text-decoration: underline;
  }

  .message,
  .hover-message {
    display: flex;
    flex-direction: row;
    place-items: center;
    gap: ${({ theme }) => theme.space.space8};
    color: ${({ theme, textColor }) => textColor || theme.colors.tone.black};
    font-size: ${({ theme }) => theme.fontSizes.fontSize14};
    font-weight: 600;
    opacity: 1;
    transition: transform 350ms ease-in-out, opacity ease-in-out;
  }

  .hover-message {
    position: absolute;
    transform: translateY(${({ theme }) => theme.space.space64});
    left: ${({ theme }) => theme.space._12};
  }

  &:hover:not(.success):not(.no-hover) {
    .message {
      transform: translateY(${({ theme }) => `-${theme.space.space64 || 0}`});
    }

    .hover-message {
      transform: translateY(0);
    }
  }

  .copy-success {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    place-items: center;
    gap: ${({ theme }) => theme.space.space8};
    padding: ${({ theme }) => theme.space._12};
    background-color: #c8f2cc;
    opacity: 0;
    color: ${({ theme }) => theme.colors.tone.black};
    font-size: ${({ theme }) => theme.fontSizes.fontSize14};
    font-weight: 600;
    transition: opacity 350ms ease-in-out;
    text-align: left;

    .icon-success {
      flex-shrink: 0;

      path {
        fill: ${({ theme }) => theme.colors.semantic.green};
      }
    }
  }

  &.success {
    background-color: transparent;
    pointer-events: none;

    .copy-success {
      opacity: 1;
    }

    .message,
    .hover-message,
    .icon {
      opacity: 0;
    }
  }
`;
